import React, { useEffect } from "react";
import { Collapse, Spin, Typography, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { Logger, useLoggerTableGet } from "../../../../hooks/api/responses";
import { NavLink } from "react-router";

const { Text, Link } = Typography;

interface Props {
  entityId: string;
}

export default function LoggerCollapse({ entityId }: Props) {
  const loggersApi = useLoggerTableGet();

  useEffect(() => {
    if (!entityId) return;
    loggersApi.fetch({
      event: "update",
      entity: "survey-response",
      entityId,
    });
  }, [entityId]);

  const logs = loggersApi.data?.data || [];

  const columns: ColumnsType<Logger> = [
    {
      title: "Edited by",
      dataIndex: "user",
      key: "user",
      render: (_, record) => (
        <NavLink
          to={`/users/${record.user?.id}/edit`}
          style={{ textDecoration: "underline" }}
        >
          {record.user
            ? `${record.user.firstName || ""} ${record.user.lastName || ""}`.trim()
            : ""}
        </NavLink>
      ),
    },
    {
      title: "Edited at",
      dataIndex: "createdAt",
      key: "editedAt",
      render: (date: string, record) =>
        dayjs
          .utc(date)
          .add(Number(record.userTimezone || 0), "hour")
          .format("YYYY-MM-DD HH:mm:ss"),
    },
  ];

  if (loggersApi.loading) {
    return <Spin />;
  }

  if (!logs.length) {
    return <Text type="secondary">No logs found</Text>;
  }

  return (
    <div style={{ paddingTop: 24 }}>
      <Collapse
        bordered
        styles={{
          root: {
            backgroundColor: "#FFFFFF",
            overflow: "hidden",
            border: "none",
          },
        }}
        items={[
          {
            key: "edition",
            label: "Edition",
            children: (
              <Table
                columns={columns}
                dataSource={logs}
                rowKey="id"
                pagination={false}
                size="small"
              />
            ),
          },
        ]}
      />
    </div>
  );
}
